import { render, staticRenderFns } from "./DeletePanelConfirm.vue?vue&type=template&id=41948616&"
import script from "./DeletePanelConfirm.vue?vue&type=script&lang=js&"
export * from "./DeletePanelConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports